import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import {
  SEditor,
} from '@simmons/components';
import { computed } from 'vue';
import DOMPurify from 'dompurify';

import genericRichTextEditorBundle from '@/../editor/src/genericRichTextEditor/ckeditor';
import { getEditorConfig } from '@/../editor/src/genericRichTextEditor/config';
import enableEditorDevTools from '@/utils/enableEditorDevTools';


export default /*#__PURE__*/_defineComponent({
  props: {
  initialValue: {
    type: String,
    default: '',
  },
},
  emits: ["change"],
  setup(__props, { emit }: { emit: ({(event: 'change', value: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props

// eslint-disable-next-line import/extensions




// eslint-disable-next-line max-len
const editorConfig = computed(() => getEditorConfig({ initialEditorData: DOMPurify.sanitize(props.initialValue) }));

const setupEditorPlugins = (editor: ClassicEditor): void => {
  if (editor.plugins.has('TrackChangesUI')) {
    editor.execute('trackChanges');
  }
};

const handleEditorReady = async (event: { id: string, editor: ClassicEditor }) => {
  const { editor } = event;
  await enableEditorDevTools(editor);
  setupEditorPlugins(editor);
};

const handleBlur = (event: { id: string, editor: ClassicEditor }) => {
  const { editor } = event;
  const data = editor.getData();
  emit('change', data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SEditor), {
    class: "generic-editor",
    "editor-bundle": _unref(genericRichTextEditorBundle),
    config: _unref(editorConfig),
    onBlur: handleBlur,
    onReady: handleEditorReady
  }, null, 8, ["editor-bundle", "config"]))
}
}

})